import React from 'react';
import { observer } from 'mobx-react-lite';
import Popup from '../common-components/pop-up/Popup';
import { FolderDown } from 'lucide-react';
import CommonButton from '../common-components/button/CommonButton';
import styles from './FilesDialog.module.css';
import FilesService from '../../services/files.service';
import { useStore } from '../../hooks/useStore';

const FilesDialog: React.FC = () => {
  const { popupStore } = useStore();

  const handleClose = () => popupStore.setIsFilesDialogOpen(false);

  const handleDownloadEImza = async () => {
    try {
      await FilesService.downloadEImza();
    } catch (error) {
      console.error(error);
    }
  };

  const handleDownloadApk = async () => {
    try {
      await FilesService.downloadApk();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Popup
      isOpen={popupStore.isFilesDialogOpen}
      onClose={handleClose}
      title="Dosyalar"
      description="Kurulum dosyalarını indirin"
      variant="info"
      icon={<FolderDown size={22} strokeWidth={2} />}
    >
      <div className={styles.container}>
        <p className={styles.description}>Güncel kurulum dosyalarına buradan erişebilirsiniz.</p>
        <div className={styles.buttons}>
          <CommonButton type="secondary" onClick={handleDownloadEImza}>
            E-İmza Kurulum Paketini İndir
          </CommonButton>
          <CommonButton type="primary" onClick={handleDownloadApk}>
            Mobil Uygulama APK'sını İndir
          </CommonButton>
        </div>
      </div>
    </Popup>
  );
};

export default observer(FilesDialog);
